module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//red_2.png?v=5c981a53";